import React, { useCallback, useEffect, useState } from 'react';
import { Button, Slider} from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Cropper from 'react-easy-crop';
import cropImageUtil from './CropImageUtil';
import Constant from '@/common/constant/Constant';

import './StylesCrop.css';
import trI18n from '@/common/utils/trI18n';
import { useTranslationSubscription } from '@/hooks/useTranslation';

function CropImage({
    inputImage,
    setInputImage,
    aspect,
    cropShape,
    openCrop,
    setOpenCrop,
    setCroppedImage,
    setImagePreview,
    setErrorImage,
    onCloseCallback,
    imageName,
    setImageName,
    oldImageName,
    setOldImageName,
    setIsEdited

}) {
    useTranslationSubscription();
    const [crop, setCrop] = useState({ x: 0, y: 0 });
    const [zoom, setZoom] = useState(1);
    const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);

    const handleClose = (event, reason) => {
        //disable backdropClick
        if (reason === "backdropClick") {
            return false;
        }
        setOpenCrop(false);
    };

    useEffect(() => {
        if (inputImage) {
            cropImageUtil.checkValidImage(inputImage)
                .then((image) => {
                })
                .catch((err) => {
                    if (err.type === 'error') {
                        console.log('__________________invalid image input', err);
                        setErrorImage('USER01MSG007');
                        setInputImage('');
                        if (typeof setImagePreview === 'function'){
                            setImagePreview(Constant.BLANK_IMAGE);
                        }
                        handleClose();
                    }
                });
        }
    }, [inputImage]);

    const onCropComplete = useCallback((croppedArea, croppedAreaPixelsResult) => {
        setCroppedAreaPixels(croppedAreaPixelsResult);
    }, []);

    const showCroppedImage = useCallback(async () => {
        try {
            const croppedImage = await cropImageUtil.getCroppedImg(inputImage, croppedAreaPixels);
            if (typeof setImagePreview === 'function'){
                setImagePreview(croppedImage.image);
            }
            setCroppedImage(croppedImage);
            setErrorImage('');
            setZoom(1);
            setCrop({ x: 0, y: 0 });
            if (setOldImageName) setOldImageName(imageName)
            if(setIsEdited) {
                setIsEdited(true);
            }
            handleClose();
        } catch (e) {
            console.error(e);
        }
    }, [croppedAreaPixels]);

    const changeZoom = (step) => {
        if (step < 0) {
            if (zoom > 1) {
                setZoom(zoom + step);
            }
        } else {
            if (zoom < 3) {
                setZoom(zoom + step);
            }
        }
    };

    const cancelCrop = () => {
        setZoom(1);
        setCrop({ x: 0, y: 0 });
        if (setImageName) setImageName(oldImageName);
        if (onCloseCallback && typeof onCloseCallback === 'function') {
            onCloseCallback();
        } else {
            handleClose();
        }
    };

    return (
        <React.Fragment>
            <Dialog
                open={openCrop}
                onClose={(event, reason) => handleClose(event, reason)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                className="wrapDialog"
            >
                <DialogContent>
                    <div className="wrapCrop">
                        <div className="cropContainer">
                            {cropShape === 'round' ? (
                                <Cropper
                                    image={inputImage}
                                    crop={crop}
                                    zoom={zoom}
                                    aspect={aspect}
                                    onCropChange={setCrop}
                                    onCropComplete={onCropComplete}
                                    onZoomChange={setZoom}
                                    cropShape="round"
                                />
                            ) : (
                                <Cropper
                                    image={inputImage}
                                    crop={crop}
                                    zoom={zoom}
                                    aspect={aspect}
                                    onCropChange={setCrop}
                                    onCropComplete={onCropComplete}
                                    onZoomChange={setZoom}
                                />
                            )}
                        </div>
                        <div className="controls">
                            <div className="sliderContainer">
                                <Button
                                    className="btn-zoom btn-zoom--small"
                                    onClick={(e) => changeZoom(-0.1)}
                                    variant="contained"
                                    color="primary"
                                >
                                    -
                                </Button>
                                <Slider
                                    value={zoom}
                                    min={1}
                                    max={3}
                                    step={0.1}
                                    aria-labelledby="Zoom"
                                    className="slider"
                                    onChange={(e, val) => setZoom(val)}
                                />
                                <Button
                                    className="btn-zoom btn-zoom--large"
                                    onClick={(e) => changeZoom(0.1)}
                                    variant="contained"
                                    color="primary"
                                >
                                    +
                                </Button>
                            </div>
                        </div>
                    </div>
                </DialogContent>
                <DialogActions className="btnCrop">
                    <Button onClick={showCroppedImage} variant="contained" color="primary">
                        {trI18n('COMBTN003')}
                    </Button>

                    <Button onClick={cancelCrop} variant="contained">
                        {trI18n('COMBTN001')}
                    </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}

export default CropImage;
